import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProfileSelector.css"; // Import the CSS file for styling
import logoAyuntamiento from "../assets/img/logo_ayuntamiento.png";

const perfiles = [
  { nombre: "Ciudadan@s", imagen: "/images/ciudadanos.png" },
  { nombre: "Ciudades", imagen: "/images/ciudades.png" },
  { nombre: "Gestión", imagen: "/images/gestion.png" },
  { nombre: "Tecnología", imagen: "/images/tech.png" },
  { nombre: "Alta Dirección", imagen: "/images/altadir.png" },
];

const ProfileSelector = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/evd");
  };

  return (
    <div className="seleccion-perfil">
      <div className="logo-ayuntamiento">
        <img
          src={logoAyuntamiento}
          width={400}
          alt="Logo del Ayuntamiento de Madrid"
          style={{ cursor: "pointer" }}
        />
        <br />
        <span>Oficina Digital</span>
      </div>
      <h1>¿Quién es nuestra audiencia?</h1>
      <div className="perfiles">
        {perfiles.map((perfil) => (
          <div key={perfil.nombre} className="perfil" onClick={handleLogoClick}>
            <img src={perfil.imagen} alt={`Perfil de ${perfil.nombre}`} />
            <span>{perfil.nombre}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSelector;
